import React from 'react';
import PropTypes from 'prop-types';
import { childrenPropType, stylePropType, H1, TSS_DARK_BLUE, range, TSS_RED } from 'tss-core-lib-common';
import { css, StyleSheet } from '../styling';

var styles = void 0;

var Dialog = function Dialog(_ref) {
  var style = _ref.style,
      chromeStyle = _ref.chromeStyle,
      contentStyle = _ref.contentStyle,
      children = _ref.children,
      step = _ref.step,
      totalSteps = _ref.totalSteps;
  return React.createElement(
    'div',
    { className: css(styles.container, style) },
    React.createElement(
      'div',
      { className: css(styles.chrome, chromeStyle) },
      range(totalSteps).map(function (s) {
        return React.createElement('span', { key: s, className: css(styles.step, s + 1 === step && styles.currentStep) });
      })
    ),
    React.createElement(
      'div',
      { className: css(styles.content, contentStyle) },
      children
    )
  );
};

Dialog.propTypes = {
  style: stylePropType,
  chromeStyle: stylePropType,
  contentStyle: stylePropType,
  children: childrenPropType.isRequired,
  step: PropTypes.number,
  totalSteps: PropTypes.number
};

Dialog.defaultProps = {
  style: null,
  chromeStyle: null,
  contentStyle: null,
  step: 0,
  totalSteps: 0
};

var propTypes = {
  children: childrenPropType.isRequired
};

var DialogSubject = function DialogSubject(_ref2) {
  var children = _ref2.children;
  return React.createElement(
    'h4',
    { className: css(styles.subject) },
    children
  );
};

DialogSubject.propTypes = propTypes;

var DialogHeading = function DialogHeading(_ref3) {
  var children = _ref3.children;
  return React.createElement(
    'h1',
    { className: css(H1, styles.heading) },
    children
  );
};

DialogHeading.propTypes = propTypes;

var DialogParagraph = function DialogParagraph(_ref4) {
  var children = _ref4.children;
  return React.createElement(
    'p',
    { className: css(styles.paragraph) },
    children
  );
};

DialogParagraph.propTypes = propTypes;

var DialogWarningParagraph = function DialogWarningParagraph(_ref5) {
  var children = _ref5.children;
  return React.createElement(
    'p',
    { className: css(styles.paragraph, styles.warningParagraph) },
    children
  );
};

DialogWarningParagraph.propTypes = propTypes;

var DialogButtonRow = function DialogButtonRow(_ref6) {
  var children = _ref6.children;
  return React.createElement(
    'div',
    { className: css(styles.buttonRow) },
    children
  );
};

DialogButtonRow.propTypes = propTypes;

var DialogContent = function DialogContent(_ref7) {
  var children = _ref7.children,
      style = _ref7.style;
  return React.createElement(
    'div',
    { className: css(styles.childContent, style) },
    children
  );
};

DialogContent.propTypes = {
  children: childrenPropType.isRequired,
  style: stylePropType
};

DialogContent.defaultProps = {
  style: null
};

styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    width: '70rem',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.06)',
    maxHeight: '90vh',
    overflow: 'auto'
  },

  chrome: {
    height: '4rem',
    padding: '0 1.6rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  step: {
    width: '0.8rem',
    height: '0.8rem',
    backgroundColor: TSS_DARK_BLUE(0.5),
    border: 0,
    borderRadius: '50%',
    margin: '0 0.4rem'
  },

  currentStep: {
    backgroundColor: TSS_DARK_BLUE
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '4.7rem 3rem 8.7rem 3rem',
    fontSize: '1.4rem',

    '>:first-child': {
      marginTop: 0
    }
  },

  subject: {
    fontSize: '1.4rem',
    color: TSS_DARK_BLUE(0.5),
    margin: '1.5rem 0 0 0'
  },

  heading: {
    margin: '1.5rem 0 0 0'
  },

  paragraph: {
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE,
    margin: '1.5rem 0 0 0',
    width: '100%'
  },

  warningParagraph: {
    color: TSS_RED
  },

  childContent: {
    margin: '3rem 0 1.5rem 0'
  },

  buttonRow: {
    maxWidth: '90%',
    margin: '2.5rem 0 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '>.tss-button': {
      margin: '0 1rem'
    }
  }
});

export { Dialog, DialogSubject, DialogHeading, DialogParagraph, DialogContent, DialogButtonRow, DialogWarningParagraph };